<template>
  <div class="table-state">
    <div class="table-state__block">
      <HeaderBox queue-table-hook>
        <HeaderBoxItem>
          {{ stateLeft }}
        </HeaderBoxItem>
      </HeaderBox>
      <div class="table-state__grid">
        <TicketState v-for="(ticket, index) in spliceItems(ticketsStateLeft)"
                     class="ticket-state_light"
                     :key="`table-cols__grid-${index}`"
                     :item="ticket"/>
      </div>
    </div>
    <div class="table-state__block">
      <HeaderBox queue-table-hook>
        <HeaderBoxItem>
          {{ stateRight }}
        </HeaderBoxItem>
      </HeaderBox>
      <div class="table-state__grid">
        <TicketState v-for="(ticket, index) in spliceItems(ticketsStateRight)"
                     class="ticket-state_dark"
                     :key="`table-cols__grid-${index}`"
                     :item="ticket"/>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex'

import TicketState from '@/components/tickets/TicketState'
import HeaderBox from '@/components/headers/HeaderBox'
import HeaderBoxItem from '@/components/headers/HeaderBoxItem'

export default {
  name: 'TableState',
  components: {
    HeaderBoxItem,
    HeaderBox,
    TicketState
  },
  props: {
    tickets: {
      type: Array
    }
  },
  computed: {
    ...mapState({
      states: state => state.board.states,
      boardSize: state => state.board.size
    }),
    stateLeft () {
      return this.states[0].getTitle()
    },
    stateRight () {
      return this.states[1].getTitle()
    },
    ticketsStateLeft () {
      return this.tickets.filter(ticket => ticket.getTitle() === this.stateLeft)
    },
    ticketsStateRight () {
      return this.tickets.filter(ticket => ticket.getTitle() === this.stateRight)
    }
  },
  methods: {
    spliceItems (items) {
      return items.slice(0, this.boardSize / 2)
    }
  }
}
</script>
